module.exports = __webpack_public_path__ + "img/awesome-walking.svg";